import { Text } from "react-native-paper";
import Animated, {
	type SharedValue,
	useAnimatedStyle,
	interpolate,
	Extrapolation,
} from "react-native-reanimated";
import { COVER_TEXT_COLOR } from "./constants";

type Props = {
	title: string;
	scrollY: SharedValue<number>;
	titleScrollThreshold: number;
	isTransparent: boolean;
	isScrollAware: boolean;
};

export const AnimatedHeaderTitle = ({
	title,
	scrollY,
	titleScrollThreshold,
	isTransparent,
	isScrollAware,
}: Props) => {
	const hasAnimatedTitle = isScrollAware && titleScrollThreshold > 0;
	const titleColor = isTransparent ? COVER_TEXT_COLOR : undefined;

	const compactTitleStyle = useAnimatedStyle(() => {
		if (isScrollAware) {
			if (!hasAnimatedTitle) {
				return { opacity: 0 };
			}
			return {
				opacity: interpolate(
					scrollY.value,
					[titleScrollThreshold, titleScrollThreshold + 40],
					[0, 1],
					Extrapolation.CLAMP,
				),
			};
		}
		return { opacity: 1 };
	});

	return (
		<Animated.View
			style={[{ height: 40, justifyContent: "center" }, compactTitleStyle]}
		>
			<Text
				variant="titleMedium"
				numberOfLines={1}
				style={titleColor ? { color: titleColor } : undefined}
			>
				{title}
			</Text>
		</Animated.View>
	);
};
